@if (occurrences.length > 0) {
  <section class="schedule-preview">
    <h3>Upcoming occurrences</h3>
    @for (occurrence of occurrences; track occurrence) {
      <div class="occurrence-row">
        <div>Occurrence {{ occurrence.SequenceNumber }}</div>
        <div>{{ occurrence.LocalStartDateTime | date: 'medium' }} {{ occurrence.TimeZoneId }}</div>
        <div>{{ occurrence.ExecutionDateTimeUtc | date: 'medium':'UTC' }} UTC</div>
      </div>
    }
  </section>
}
